// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__305X3","text":"style_text__1qDl_","point":"style_point__3Gd83","point__green":"style_point__green__2vosI","point__red":"style_point__red__CLc0D"};